import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import './Hero.scss';
import styles from './carrier.scss';

const Hero = ({ subject, priorCarrier, text }) => {
    if (!priorCarrier) return null;
    const carrier = priorCarrier.toLowerCase().replace(/ /g, '-');

    return (
        <div>
            <div
                className="hero flex flex-row"
                style={{
                    backgroundColor: styles[`${carrier}-background`]
                }}>
                <div className="business-partner">
                    <div>{subject}</div>
                    <h2>{priorCarrier}</h2>
                </div>

                <div
                    className="icon flex flex-column"
                    style={{
                        backgroundColor: styles[`${carrier}-icon-background`]
                    }}>
                    <FontAwesome
                        name={styles[`${carrier}-icon-name`] || ''}
                        size="2x"
                        datacy="handshake"
                    />
                </div>
                <div className="text">
                    <h1>{text}</h1>
                </div>
            </div>
        </div>
    );
};

Hero.propTypes = {
    priorCarrier: PropTypes.string.isRequired,
    text: PropTypes.string,
    subject: PropTypes.string
};

Hero.defaultProps = {
    priorCarrier: '',
    text: '',
    subject: ''
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.jsx